export default __webpack_public_path__ + "static/media/orange-circuits.7e820356.png";